import React, { FC } from 'react';
import { Route, useHistory } from 'react-router-dom';
// api
import { apiApp } from '../../api/app';
import PageTransition from '../atoms/pageTransition';
import { getAuthenticatedHomeRoute } from '../../tools/authToken';

export interface LoginLayoutProps {
  component: React.FunctionComponent<any>;
  path: string | Array<string>;
  exact: boolean;
}

const PUBLIC_AUTH_PATHS = ['/registration', '/forgot-password', '/reset-password'];

const LoginLayout: FC<LoginLayoutProps> = ({ component: Component, ...args }: LoginLayoutProps) => {
  const history = useHistory();
  const routePath = Array.isArray(args.path) ? args.path[0] : args.path;
  const accessTokenCheck = apiApp.decodeToken(localStorage.getItem('accessToken'), 'date');
  const isPublicAuthRoute = PUBLIC_AUTH_PATHS.includes(routePath);

  const redirect = () => {
    setTimeout(() => {
      history.push(getAuthenticatedHomeRoute());
    }, 0);
  };

  return (
    <Route
      path={args.path}
      exact={args.exact}
      render={() => {
        if (accessTokenCheck && !isPublicAuthRoute) {
          redirect();
          return null;
        }
        return (
          <PageTransition>
            <Component {...args} />
          </PageTransition>
        );
      }}
    />
  );
};

export default LoginLayout;
